/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Team } from './team';


export interface TeamResultResponse { 
    /**
     * the total number of results
     */
    count: number;
    result: Array<Team>;
}

